function initCtrPerfumeWardrobeSwiper(section) {
  if (typeof Swiper === 'undefined') return;

  var carousel = section.querySelector('[data-ref="reviewsSwiper"]');
  var reviews = section.querySelector('.ctr-perfume-wardrobe__reviews');
  if (!carousel || !reviews || carousel.swiper) return;

  new Swiper(carousel, {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    speed: 600,
    autoHeight: true,
    navigation: {
      nextEl: reviews.querySelector('.swiper-button-next'),
      prevEl: reviews.querySelector('.swiper-button-prev'),
      addIcons: false,
    },
    pagination: {
      el: carousel.querySelector('.swiper-pagination'),
      clickable: true,
    },
    breakpoints: {
      990: {
        spaceBetween: 24,
      },
    },
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ctr-perfume-wardrobe[data-section-id]').forEach(initCtrPerfumeWardrobeSwiper);
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.ctr-perfume-wardrobe[data-section-id]');
    if (section) initCtrPerfumeWardrobeSwiper(section);
  });
}
